<template>
    <footer class="bg-slate-950 py-8 px-4 sm:px-6 lg:px-8 border-t border-slate-800">
      <div class="max-w-6xl mx-auto">
        <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p class="text-slate-500 text-sm">
            &copy;2020 – {{ new Date().getFullYear() }} Wendm Werku. All rights reserved.
          </p>
          <p class="text-slate-600 text-sm">
            Built with <span class="text-emerald-500">Vue.js</span> & <span class="text-emerald-500">Tailwind CSS</span>
          </p>
        </div>
      </div>
    </footer>
</template>
